// src/theme/tokens/colors.js
// Source of truth for Figma design-system colors (Default mode)

export const colors = {
  // Base
  white: '#FFFFFF',
  black: '#000000',

  // Blue Accent Button
  accentBlueButton: '#0A84FF',  // iOS-style blue for accent buttons

  // Accents
  accentBlue: '#2D66D1',
  accentYellow: '#FFC619',
  accentRed: '#FD0203',

  // Freshly Squeezed
  freshlySqueezed1: '#FFBF00',
  freshlySqueezed2: '#FFC27E',
  freshlySqueezed3: '#FFE642',
  freshlySqueezed4: '#FF7900',

  // Blue
  blue2: '#2171D1',
  blue3: '#113176',
  blueSemi: 'rgba(33, 113, 209, 0.25)',

  // Orange
  orange2: '#FF9600',
  orange3: '#764500',
  orangeSemi: 'rgba(255, 150, 0, 0.25)',

  // Red
  red2: '#D0113D',
  red3: '#A51930',
  redSemi: 'rgba(208, 17, 61, 0.25)',

  // Yellow
  yellow2: '#FEC778',
  yellow3: '#764500',
  yellowSemi: 'rgba(254, 199, 120, 0.25)',

  // Greens (Figma naming)
  green2: '#02875B',
  green3: '#015136',
  greenSemi: 'rgba(2, 135, 91, 0.25)',

  // UI Greys
  uiGrey1: '#131618',
  uiGrey2: '#1B1F22',
  uiGrey3: '#141719',
  uiGrey4: '#252B2D',

  // Neutrals
  almostBlack: '#222222',
  darkGrey: '#404040',
  lightGrey: '#ABABAB',

  // Translucent
  translucentBlack: 'rgba(0, 0, 0, 0.9)',
  translucentLightGrey: 'rgba(171, 171, 171, 0.8)',
};

